export const MINIMUM_DELIVERY_DATE = 5
export const MAXIMUM_DELIVERY_DATE = 8
